import {observer} from "mobx-react";
import * as React from "react";
import FormContainer from "../../layout/FormContainer/FormContainer";
import {FormComponent} from "../../state/FormsState";
import {RouteComponentProps} from "react-router";

interface ILocalState {}
interface IProps extends RouteComponentProps<any> {}

@observer
export default class FormConnectBankContainer extends React.Component<IProps> {
    public state: ILocalState = {};
    public render() {
        return (
            <FormContainer initialComponent={FormComponent.connectBank}  {...this.props}/>
        );
    }
}



// WEBPACK FOOTER //
// ./src/scenes/Forms/screens/FormConnectBank/FormConnectBankContainer.tsx